import scheduledCalls from './scheduled-calls-tab.png'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default ({ alt }): React.ReactElement => <img width="298px" height="229px" src={scheduledCalls} alt={alt} />
